<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'reports.overview.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    <app-data-table [configuration]="dataTableConfiguration"></app-data-table>
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="dismiss()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
